import { LeftPanel } from "helpers/constants";
import { AppContext, setLeftPanel } from "helpers/context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import styles from "./my-shapes.module.scss";
import { IconButton } from "@mui/material";
import ShapeList from "./shape-list/shape-list";
import { ReactComponent as Locally } from "assets/sync_saved_locally.svg";

function MyShapes() {
  const [context, dispatch] = useContext(AppContext);
  const locationsSize = context.locationsSize;
  const [t] = useTranslation();

  return (
    <div
      className={styles.locations}
      style={{ width: locationsSize ? "800px" : "400px" }}
    >
      <div className={styles.header}>
        <div className={`${styles.title} flex items-center`}>
          <div>{t("myShapes.title")}</div>

          <div className="ml-[10px] w-[21px] h-[21px] rounded-full flex items-center justify-center cursor-pointer">
            <Locally className="w-[21px] h-[21px] block" />
          </div>

          <div className="ml-auto">
            <IconButton onClick={() => setLeftPanel(dispatch, LeftPanel.Empty)}>
              <span className="material-icons">close</span>
            </IconButton>
          </div>
        </div>
      </div>

      {context.myShapesListStatus === "1" ? (
        <div className={styles.loading}>
          <div className="loading loading-spinner loading-lg"></div>
          <div>{t("layers.loading")}</div>
        </div>
      ) : (
        <ShapeList />
      )}
    </div>
  );
}

export default MyShapes;


